<admin-app-header></admin-app-header>

<div class="admyt-centers-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Admyt Centers</h1>
            <div class="page-header__actions">
                <button class="btn btn-secondary" (click)="loadCentersWithParkings()">
                    <i class="fa-solid fa-refresh"></i> Refresh
                </button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid" *ngIf="!loading && !error">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-location-dot"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Centers</span>
                    <span class="stat-card__value">{{ centers.length }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-warehouse"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Related Parkings</span>
                    <span class="stat-card__value">{{ getTotalParkings() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--orange">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-link-slash"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Unlinked Centers</span>
                    <span class="stat-card__value">{{ getUnlinkedCenters() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--purple">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-chart-simple"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Avg Parkings/Center</span>
                    <span class="stat-card__value">{{ getAvgParkingsPerCenter() | number:'1.1-1' }}</span>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading Admyt centers...</p>
        </div>

        <!-- Error State -->
        <div class="error-state" *ngIf="error">
            <i class="fa-solid fa-exclamation-triangle"></i>
            <h3>Error Loading Centers</h3>
            <p>{{ error }}</p>
            <button class="btn btn-primary" (click)="loadCentersWithParkings()">
                <i class="fa-solid fa-refresh"></i> Try Again
            </button>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!loading && !error && centers.length === 0">
            <i class="fa-solid fa-location-dot"></i>
            <h3>No Centers Found</h3>
            <p>There are no Admyt centers configured.</p>
        </div>

        <!-- Centers Table -->
        <div class="table-card" *ngIf="!loading && !error && centers.length > 0">
            <table class="centers-table">
                <thead>
                    <tr>
                        <th>Center ID</th>
                        <th>Center Name</th>
                        <th>Related Parkings</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let center of centers" class="center-row">
                        <td>
                            <code class="center-id">{{ center.id }}</code>
                        </td>
                        <td>
                            <span class="center-name">{{ center.name }}</span>
                        </td>
                        <td>
                            <div class="parkings-cell">
                                <span *ngIf="center.relatedParkings.length === 0" class="no-parkings">
                                    <i class="fa-solid fa-link-slash"></i> No linked parkings
                                </span>
                                <div *ngIf="center.relatedParkings.length > 0" class="parkings-list">
                                    <span class="parkings-count">
                                        <i class="fa-solid fa-warehouse"></i> {{ center.relatedParkings.length }} parking(s)
                                    </span>
                                    <div class="parkings-details">
                                        <div *ngFor="let parking of center.relatedParkings" class="parking-item">
                                            <a [routerLink]="['/parking', parking.$key]" class="parking-link">
                                                <i class="fa-solid fa-external-link-alt"></i>
                                                {{ parking.title || 'Unnamed Parking' }}
                                            </a>
                                            <span class="parking-location">{{ parking.parkingLocation?.city || 'No location' }}</span>
                                            <a [routerLink]="['/merchant', parking.merchantRef?.id, 'parking', parking.$key]" 
                                               class="edit-link" 
                                               title="Edit parking">
                                                <i class="fa-solid fa-pencil"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <a [routerLink]="['/admin/admyt-center', center.id]" class="btn btn-primary btn-sm">
                                <i class="fa-solid fa-eye"></i> View Details
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
